import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';

import useAutoupdatePresenterProperty from '../../hooks/useAutoupdatePresenterProperty';
import { getCurrentUser } from '../../selectors/currentUser';
import PopupSystem from '../../systems/PopupSystem';
import UserPreferencesSystem from '../../systems/UserPreferencesSystem';
import TwoFactorAuthenticationCardPresenter from './TwoFactorAuthenticationCardPresenter';

const useTwoFactorAuthenticationCardPresenter = () => {
	const dispatch = useDispatch();
	const snackbarSystem = useSnackbarSystem();

	const currentUser = useSelector(
		state => getCurrentUser( state )
	);

	const createPresenter = () => {
		const popupSystem = new PopupSystem( dispatch );
		const userPreferencesSystem = new UserPreferencesSystem( dispatch );

		return new TwoFactorAuthenticationCardPresenter( {
			currentUser,
			popupSystem,
			snackbarSystem,
			userPreferencesSystem
		} );
	};

	const [ presenter ] = useState( createPresenter );

	useAutoupdatePresenterProperty( { presenter, name: 'currentUser', value: currentUser } );

	return presenter;
};

export default useTwoFactorAuthenticationCardPresenter;
